// extracted by mini-css-extract-plugin
export default {"root":"Login_root__a2Oww","form_wrapper":"Login_form_wrapper__1coFC"};